<template>
  <ul class="branches-categories">
    <b-collapse animation="" :open="isOpen" @open="open" @close="close" aria-id="right-categories-list">
      <li
        class="list_header categories"
        id="branch-collapse-header"
        slot="trigger"
        aria-controls="right-categories-list"
      >
        <span class="left"> <i class="icon-button-arrow"></i>Филиалы </span>
      </li>
      <li class="list_item active" v-for="(branch, i) in branchesList" :key="i">
        <router-link :to="'/branches/' + branch.id">
          <span class="left">
            {{ branch.name }}
          </span>
        </router-link>
      </li>
    </b-collapse>
  </ul>
</template>

<script>
export default {
  props: {
    branchesList: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    open() {
      document.getElementById('branch-collapse-header').classList.add('active')
    },
    close() {
      document.getElementById('branch-collapse-header').classList.remove('active')
    }
  }
}
</script>
